import { memo, ComponentType } from "react";

type EqualityFn<P> = (
  prevProps: Readonly<P>,
  nextProps: Readonly<P>,
) => boolean;

export function withMemo<P extends object>(
  Component: ComponentType<P>,
  propsAreEqual?: EqualityFn<P>,
) {
  const displayName = Component.displayName || Component.name || "Component";
  const WrappedComponent = memo(Component, propsAreEqual);
  WrappedComponent.displayName = `withMemo(${displayName})`;
  return WrappedComponent;
}

export function createPropsAreEqual<P extends object>(keys: (keyof P)[]) {
  return (prevProps: P, nextProps: P) => {
    return keys.every((key) => prevProps[key] === nextProps[key]);
  };
}
